import React from "react";
import { Badge } from "reactstrap";
import "./single-select.scss";
import CustomChip from "../chip";

class SingleSelectQuestion extends React.Component {
  state = {
    device: "mobile",
    answer: true,
  };
  componentDidMount() {
    this.setState({
      device: window.screen.availWidth < 850 ? "mobile" : "web",
    });
  }
  getSelected(isChecked, value) {
    console.log(isChecked, " : ", value);

    if (isChecked) {
      return this.concatArray([value], []);
    } else {
      return this.spliceArray(this.props.selected, [value]);
    }
  }
  concatArray(arr1, arr2) {
    var uniqueArray = [];
    let tempArr = arr1.concat(arr2);
    // Loop through array values
    for (var value of tempArr) {
      if (uniqueArray.indexOf(value) === -1) {
        uniqueArray.push(value);
      }
    }
    return uniqueArray;
  }
  spliceArray(original, remove) {
    return original.filter((value) => !remove.includes(value));
  }
  render() {
    return (
      <div className="single-select-container">
        <h3 className="font-weight-bold mb-24 mb-mobile-24">
          {this.props.title}
        </h3>
        {this.props.subTitle && (
          <h3 className=" mb-24 mb-mobile-24">{this.props.subTitle}</h3>
        )}
        <div className="chip-div">
          {this.props.options &&
            this.props.options.map((option) => {
              return (
                <>
                  <CustomChip
                    title={option.title}
                    iconClass={"fa-check"}
                    checked={this.props.selected.includes(option.value)}
                    onChecked={(value) => {
                      console.log(this.getSelected(value, option.value));

                      this.props.onAnswered(
                        this.getSelected(value, option.value)
                      );
                    }}
                  />
                  {/* &nbsp; &nbsp; */}
                </>
              );
            })}
          {/* <CustomChip
            title="Yes"
            checked={this.state.answer}
            onChecked={(value) => {
              this.setState({
                answer: value,
              });
            }}
          />
          &nbsp; &nbsp;
          <CustomChip
            title="No"
            checked={!this.state.answer}
            onChecked={(value) => {
              this.setState({
                answer: !value,
              });
            }}
          /> */}
        </div>
      </div>
    );
  }
}

export default SingleSelectQuestion;
